import IssuerHoverCardFields from "components/issuers/graphql/fragments/IssuerHoverCardFields";
import gql from "graphql-tag";
import AssetDiscussionCommentParticipantsFields from "lib/graphql/fragments/AssetDiscussionCommentParticipantsFields";
import CommentOrReplyAuthorFields from "./CommentOrReplyAuthorFields";
import EditableCommentFields from "./EditableCommentFields";
import LockableCommentFields from "./LockableCommentFields";
import PinnableCommentFields from "./PinnableCommentFields";
import ReactableFields from "./ReactableFields";

export default gql`
  fragment AssetDiscussionCommentWithRepliesCountFields on AssetDiscussionComment {
    _id
    shortId
    bodyAsPlainText
    postedAt

    participants(top: 6) {
      ...AssetDiscussionCommentParticipantsFields
    }

    asset {
      ... on AmericanCompanyIssuer {
        _id
        name
        tickerSymbols
        sector
        isAmericanDepositaryReceipt
        businessDescription
        primaryTickerSymbol
        primaryLogo: standardLogo {
          url
        }
        niceLogo {
          url
        }
      }
      ... on BrazilianCompanyIssuer {
        _id
        name
        tickerSymbolPrefix
        sector
        isBrazilianDepositaryReceipt
        businessDescription
        primaryLogo: standardLogo {
          url
        }
        securities {
          _id
          tickerSymbol
        }
        niceLogo {
          url
        }
      }
      ... on BrazilianRealEstateFund {
        _id
        name
        tickerSymbol
        tickerSymbolPrefix
        shortDescription
        selfRegulation {
          primarySegment
        }
        primaryLogo {
          url
          width
          height
        }
      }
      ...BrazilianCompanyIssuerHoverCardFields
      ...AmericanCompanyIssuerHoverCardFields
      ...BrazilianRealEstateFundHoverCardFields
    }

    author {
      ...CommentOrReplyAuthorFields
    }

    viewerCanDestroy
    viewerCanEdit
    viewerCanReply

    ...LockableCommentFields
    ...PinnableCommentFields
    ...EditableCommentFields
    ...ReactableFields

    replies {
      totalCount
    }
  }

  ${LockableCommentFields}
  ${PinnableCommentFields}
  ${EditableCommentFields}
  ${CommentOrReplyAuthorFields}
  ${ReactableFields}
  ${AssetDiscussionCommentParticipantsFields}
  ${IssuerHoverCardFields}
`;
